import { useMutation, useQueryClient } from '@tanstack/react-query';

import { CategoriesApi } from '../../apis';
import { Category } from '../../models/categories';
import { QueryKeys } from '../query-keys';

const useUpdateCategory = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (category: Partial<Category> & { id: string }) =>
      CategoriesApi.update(category),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.CATEGORIES] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.CASHFLOWS] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.TRANSACTIONS] });
    },
  });

  return {
    updateCategory: mutation.mutateAsync,
    isUpdating: mutation.isPending,
    wasUpdatedWithSuccess: mutation.isSuccess,
    wasUpdatedWithoutSuccess: mutation.isError,
  };
};

export default useUpdateCategory;
